// extracted by mini-css-extract-plugin
module.exports = {"rateOptionsWrapper":"ua","rateOptionsRow":"ub","popover":"uc","popoverArrow":"ud"};